import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { time } from 'console';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { Produto } from 'src/app/core/models/produto.model';

@Component({
  selector: 'app-novo-pedido-olho',
  templateUrl: './novo-pedido-olho.component.html',
  styleUrls: ['./novo-pedido-olho.component.scss']
})
export class NovoPedidoOlhoComponent implements OnChanges{

  @Input() titulo: string;
  @Input() olho: NovoPedidoOlho;
  @Input() olhoSelecionadoAmbos: any;
  @Input() produtosLentes: Array<Produto>;
  produtosLentesFiltrado: Array<Produto>;

  @Output() DNPLongeChange = new EventEmitter<boolean>();
  @Output() ProdutoChange = new EventEmitter<Produto>();
  maxlength: number = 5;

  private autocompleteHandler: any = null;
  private hchangeProdutoEmit: any = null;

  ngOnChanges(changes: SimpleChanges): void {
    //
  }
  primaBasesHorizontal: any[] = [
    {
      id: 1,
      nome: 'Nasal'
    },
    {
      id: 2,
      nome: 'Temporal'
    },
    // {
    //   id: 3,
    //   nome: 'Inferior'
    // },
    // {
    //   id: 4,
    //   nome: 'Superior'
    // },
    // {
    //   id: 5,
    //   nome: 'Nasal Inferior'
    // },
    // {
    //   id: 6,
    //   nome: 'Nasal Superior'
    // },
    // {
    //   id: 7,
    //   nome: 'Temporal Inferior'
    // },
    // {
    //   id: 8,
    //   nome: 'Temporal Superior'
    // }
  ]

  primaBasesVertical: any[] = [
    // {
    //   id: 1,
    //   nome: 'Nasal'
    // },
    // {
    //   id: 2,
    //   nome: 'Temporal'
    // },
    {
      id: 3,
      nome: 'Inferior'
    },
    {
      id: 4,
      nome: 'Superior'
    },
    // {
    //   id: 5,
    //   nome: 'Nasal Inferior'
    // },
    // {
    //   id: 6,
    //   nome: 'Nasal Superior'
    // },
    // {
    //   id: 7,
    //   nome: 'Temporal Inferior'
    // },
    // {
    //   id: 8,
    //   nome: 'Temporal Superior'
    // }
  ]
  changeDNPLonge(event: Event) {
    this.DNPLongeChange.emit(true);
  }

  // changeAdicao(event: number) {
  //   // let adicao = this.olho.olhoAdicao
  //   let adicao = event;

  //   if (adicao) {
  //     let olhoLongeEsferico = this.olho.olhoLongeEsferico ?? 0;
  //     let olhoLongeDNP = this.olho.olhoLongeDNP ?? 0;

  //     this.olho.olhoPertoEsferico = olhoLongeEsferico + adicao;
  //     this.olho.olhoPertoCilindrico = this.olho.olhoLongeCilindrico;
  //     this.olho.olhoPertoEixo = this.olho.olhoLongeEixo;
  //     this.olho.olhoPertoDNP = olhoLongeDNP - 2.5;
  //   } else {
  //     this.olho.olhoPertoEsferico = this.olho.olhoLongeEsferico;
  //     this.olho.olhoPertoCilindrico = this.olho.olhoLongeCilindrico;
  //     this.olho.olhoPertoEixo = this.olho.olhoLongeEixo;
  //     this.olho.olhoPertoDNP = this.olho.olhoLongeDNP;
  //   }
  // }

  // changeEixoLonge($event: any) {
  //   console.log('eixo longe', $event, this.olho.olhoLongeEixo);
  // }

  blurLonge() {
    
    let adicao = this.olho.olhoAdicao 
    
    if (adicao) {
      let olhoLongeEsferico = this.olho.olhoLongeEsferico ?? 0;
      let olhoLongeDNP = this.olho.olhoLongeDNP ?? 0;

      this.olho.olhoPertoEsferico = Number(olhoLongeEsferico.toString().replace(',', '.')) + Number(adicao.toString().replace(',', '.'));
      this.olho.olhoPertoEsferico = this.formatarInputBlur(this.olho.olhoPertoEsferico);

      let cilindrico = this.olho.olhoLongeCilindrico ?? '';
      this.olho.olhoPertoCilindrico = this.formatarInputBlur(cilindrico);

      this.olho.olhoPertoEixo = this.formatarInputBlur(this.olho.olhoLongeEixo);
      this.olho.olhoPertoDNP = Number(olhoLongeDNP.toString().replace('.', '').replace(',', '.')) - 2.5;
      this.olho.olhoPertoDNP = this.formatarInputBlur(this.olho.olhoPertoDNP);
    }
    
    
    // else {
    //   this.olho.olhoPertoEsferico = this.olho.olhoLongeEsferico;
    //   this.olho.olhoPertoCilindrico = this.olho.olhoLongeCilindrico;
    //   this.olho.olhoPertoEixo = this.olho.olhoLongeEixo;
    //   this.olho.olhoPertoDNP = this.olho.olhoLongeDNP;
    // }
  }

  // parseNumber(value: string | undefined) {
  //   if (!value) value = '0';

  //   return Number(value.replace('.', '').replace(',', '.'));
  // }

  changeProdutoEmit($event: any) {
    const self = this;
    clearTimeout(this.hchangeProdutoEmit);
    this.hchangeProdutoEmit = setTimeout(() => {
      self.ProdutoChange.emit(self.olho.olhoLente);
    }, 1000);
  }
  
  // filterAutoComplete(event: AutoCompleteCompleteEvent) {
  //   let query = event.query;
    
  //   this.produtosLentesFiltrado = this.produtosLentes.filter(x => 
  //     x.descricao.toLowerCase().includes(query.toLowerCase()) ||
  //     (x.cod_produto != null && x.cod_produto.toString().includes(query))
  //   );
  // }

  filtrarProdutos(produto: Produto, event: AutoCompleteCompleteEvent): boolean {
    let input = event.query;
    const descricaoMatch = produto.descricao.toLowerCase().includes(input.toLowerCase());
    const codMatch = produto.cod_produto != null && produto.cod_produto.toString().includes(input);
    return descricaoMatch || codMatch;
  }
  
  async filterAutoComplete(event: AutoCompleteCompleteEvent) {
    await new Promise((resolve) => {
      this.produtosLentesFiltrado = this.produtosLentes.filter(p => this.filtrarProdutos(p, event));
      resolve(null);
    })
  }

  isOnlyNumbers(text: string): boolean {
    const regex = /^\d+$/;
    return regex.test(text);
  }

  eixoMinMax(el: any) {
    setTimeout(() => {
      if (el.value != '') {
        if (parseInt(el.target.value) < el.target.min) {
          el.target.value = el.target.min;
        }
        if (parseInt(el.target.value) > el.target.max) {     
          el.target.value = el.target.max;
        }
      }
      this.olho.olhoLongeEixo = el.target.value;
    }, 500);
  }  

  formatarInput(input: any, campo?: string): void {
    let inputNumericValue = input.value.replace(/[^\d.-]/g, '');
    const isNegative = inputNumericValue.startsWith('-');
    const isPositive = !isNegative;
    
     
    if (isPositive || isNegative) {
      
      let number = parseFloat(inputNumericValue) / 100;

      this.maxlength = isPositive ? 5 : 6;

      // Verificar o campo adição está com valor máximo permitido
      let maxAllowed ;
      if (campo === 'adicao') {
        maxAllowed = 9.99; 
        
        if (number > maxAllowed) {
          number = maxAllowed;
        } else if (number < -maxAllowed) {
          number = -maxAllowed;
        }

      }
      
      let formattedValue = number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (formattedValue === 'NaN') {
          formattedValue = '-';
      }
      //
      input.value = formattedValue;

      this.receberValorConvertido(formattedValue, campo);

    } else {
        input.value = '';
    }
  }

  receberValorConvertido(valor: any, campos?: string) {
    switch (campos) {
      case 'esfericoLonge':
        this.olho.olhoLongeEsferico = valor
        break;
      case 'dnpLonge':
        this.olho.olhoLongeDNP = valor
        break;
      case 'cilindricoLonge':
        this.olho.olhoLongeCilindrico = valor;
        break;
      case 'esfericoPerto':
        this.olho.olhoPertoEsferico = valor
        break;
      case 'dnpPerto':
        this.olho.olhoPertoDNP = valor
        break;
      case 'cilindricoPerto':
        this.olho.olhoPertoCilindrico = valor;
      break;
      case 'adicao':
        this.olho.olhoAdicao = valor;
        break;        
      case 'altura_pupila':
        this.olho.olhoAlturaPupila = valor;
        break;        
        case 'prisma_hor_valor':
          this.olho.olhoPrismaHorizontalValor = valor;
          break; 
        case 'prisma_vert_valor':
          this.olho.olhoPrismaVerticalValor = valor;
          break;
      default:
        break;
    }
  }

  converterValor(decimalStr: string) {
    const inputNumericValue = decimalStr.replace(/[^\d.-]/g, '');
    const isNegative = inputNumericValue.startsWith('-');

    let number = parseFloat(inputNumericValue) / 100;

    let formattedValue = number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (formattedValue === 'NaN') {
        formattedValue = '-';
    }
    let valorFormatado = formattedValue;
      
    return valorFormatado;
  }

  formatarInputBlur(input: any) {

    const formatoNovo = input.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2});

    return formatoNovo

  }

}

export interface NovoPedidoOlho {
  olhoLente?: Produto | undefined;

  olhoLongeEsferico?: number | undefined;
  olhoLongeCilindrico?: number | undefined;
  olhoLongeEixo?: number | undefined;
  olhoLongeDNP?: number | undefined;

  olhoAdicao?: number | undefined;

  olhoPertoEsferico?: number | undefined;
  olhoPertoCilindrico?: number | undefined;
  olhoPertoEixo?: number | undefined;
  olhoPertoDNP?: number | undefined;

  olhoAlturaPupila?: number | undefined;
  olhoPrismaHorizontalValor?: number | undefined;
  olhoPrismaVerticalValor?: number | undefined;
  olhoPrismaHorizontalBase?: any | undefined;
  olhoPrismaVerticalBase?: any | undefined;

}
